import meteringImg from "../../../assets/images/service/metering.jpg";
import {
  Settings,
  Zap,
  FileCheck,
  ShieldCheck,
  BarChart3,
  Activity,
  TrendingUp,
  Hourglass,
  UserCheck,
  Cpu,
  FileLock
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function PrecisionMetering() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Advanced <span className="green">Precision Metering</span> & Analytics
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise delivers high-accuracy HT/LT metering solutions, ensuring 
                    transparent energy tracking, utility compliance, and real-time data 
                    intelligence for industrial and commercial power consumers.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Utility-grade CT/PT metering units & smart meters</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Real-time energy monitoring & load profiling</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Automated billing & CMS software integration</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={meteringImg}
                      alt="Precision Metering Solutions"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-tachometer-alt"></i> 99.9% Billing Accuracy
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      In high-voltage environments, even a 1% error in measurement can lead to massive financial discrepancies. Denial Enterprise provides "Precision Metering" that bridges the gap between the power utility (DISCOM) and the end-user. We specialize in the installation of CT/PT units and digital smart meters that are pre-tested and certified by government-approved labs.
                    </p>
                    <p className="mb-3">
                      Beyond hardware, we provide the digital layer. Our metering systems are capable of "Time of Use" (ToU) tracking, which is essential for EV charging stations and heavy industrial plants looking to optimize their tariff costs during off-peak hours.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Cpu size={22} />
                        </span>
                        <span>Smart Metering & AMI (Advanced Metering Infrastructure)</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Activity size={22} />
                        </span>
                        <span>Harmonic Analysis & Power Quality Monitoring</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Hourglass size={22} />
                        </span>
                        <span>Tamper-proof HT Metering Cubicle Installation</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <BarChart3 size={22} />
                        </span>
                        <span>Energy Audit Reporting & Load Shedding Logic</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Why Precision Matters</h4>
                    <p className="mb-6">
                      Our metering solutions provide the transparency needed to manage high-load connections like your 4.5 MW setup, ensuring you only pay for the energy you actually consume.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Elimination of billing errors and utility disputes</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Identification of energy wastage and leakage</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Hourglass size={22} />
                        </span>
                        <span>Real-time data for peak-load management</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Seamless compliance with state DISCOM standards</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Modular integration with existing ERP/Tally systems</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Automated alerts for power surges or outages</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}